import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-tab-overview"},[_c(VCard,[_c(VCardTitle,[_vm._v(" "+_vm._s(_vm.t('Content'))+" ")]),_c(VDivider),_c(VCardText,[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }